import React from 'react';
import { Grid } from '@mui/material';
import { noTopGutterSx } from 'src/UIKit';
import { AppointmentTypeField } from '../../fields';
import { FieldWithProperties } from '../../FieldWithProperties';
import { SectionProps } from '../../../registry/sectionRegistry';

/**
 * Appointment-type field + its Visible/Required/Label properties.
 * Bound to config.appointment_type. Used by reminder.
 */
export const AppointmentTypeSection: React.FC<SectionProps> = ({
  config,
  onConfigUpdate,
  options,
  selected,
  onSelect,
}) => {
  const appointmentType = config.appointment_type;

  const update = (patch: Partial<typeof appointmentType>) =>
    onConfigUpdate({
      appointment_type: {
        ...appointmentType,
        value: appointmentType?.value ?? null,
        visible: appointmentType?.visible || false,
        required: appointmentType?.required || false,
        ...patch,
      },
    });

  return (
    <Grid item xs={12} sx={noTopGutterSx}>
      <FieldWithProperties
        visible={appointmentType?.visible ?? false}
        required={appointmentType?.required ?? false}
        hideToggles
        label={appointmentType?.label}
        onVisibleChange={visible => update({ visible })}
        onRequiredChange={required => update({ required })}
        onLabelChange={label => update({ label })}
        field={
          <AppointmentTypeField
            value={appointmentType?.value || null}
            onChange={value => update({ value })}
            visible={appointmentType?.visible || false}
            required={appointmentType?.required || false}
            isSelected={!!selected}
            onClick={() => onSelect?.()}
            label={appointmentType?.label}
            options={options?.appointmentTypes || []}
          />
        }
      />
    </Grid>
  );
};
